/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import type { BaseElementProps } from '../components/_primitives/_types'

export type NamedTuiComponent = React.ComponentType & { tuiName: string }

export type NamedTuiElement = {
  type: NamedTuiComponent
  props: BaseElementProps<HTMLElement, never>
  key: string | number | null
}

export default function (
  element: any,
  tuiNames: string[]
): element is NamedTuiElement {
  return (
    React.isValidElement(element) &&
    // @ts-ignore
    tuiNames.indexOf(element.type.tuiName) !== -1
  )
}
